<mat-card>
  <app-card-header
    title="Crear servicios técnicos masivos"
    icono="build"
    [botonCerrar]="true"
    (cerrar)="cerrarDialog()"
  ></app-card-header>

  @if (!mostrarResultados()) {
    <mat-card-content class="card-content-crear">
      <div class="form-pasos-layout">
        <app-pasos-nav
          [stepper]="stepper"
          etiqueta="Pasos del servicio técnico masivo"
        ></app-pasos-nav>

        <mat-stepper #stepper [linear]="false" class="form-pasos-stepper">
          <!-- ===== Paso 1: Filtros y selección ===== -->
          <mat-step
            [completed]="seleccionadasCount > 0"
            errorMessage="Seleccioná al menos una sirena"
          >
            <ng-template matStepLabel>Sirenas</ng-template>

            <app-content-card title="Filtros" icon="filter_alt">
              <div [formGroup]="filtrosForm">
                <section class="inputs-group">
                  <mat-form-field style="flex: 1 1 auto">
                    <mat-label>Buscar</mat-label>
                    <input
                      matInput
                      formControlName="busqueda"
                      placeholder="Chip ID, tipo, dirección..."
                    />
                    <mat-icon matPrefix>search</mat-icon>
                  </mat-form-field>

                  <button
                    irxBoton="secundario"
                    tamano="campo"
                    type="button"
                    class="boton-buscar"
                    (click)="buscarSirenas()"
                    [disabled]="buscando()"
                  >
                    @if (buscando()) {
                      <mat-spinner diameter="18"></mat-spinner>
                    } @else {
                      <mat-icon>search</mat-icon>
                    }
                    Buscar
                  </button>
                </section>

                <section class="inputs-group">
                  <app-cliente-selector
                    style="flex: 1 1 0"
                    formControlName="idCliente"
                    [filterModules]="['moduloSirenas']"
                    [clearable]="true"
                    placeholder="Todos los clientes"
                  ></app-cliente-selector>

                  <mat-form-field style="flex: 1 1 0">
                    <mat-label>Chip ID</mat-label>
                    <input matInput formControlName="chipId" />
                    <mat-icon matPrefix>sim_card</mat-icon>
                  </mat-form-field>

                  <app-modelo-dispositivo-selector
                    style="flex: 1 1 0"
                    formControlName="idModelo"
                    [tipo]="'Sirena'"
                  ></app-modelo-dispositivo-selector>
                </section>

                <section class="inputs-group">
                  <ng-select
                    style="flex: 1 1 0"
                    formControlName="estado"
                    placeholder="Estado"
                    [items]="opcionesEstado"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>

                  <ng-select
                    style="flex: 1 1 0"
                    formControlName="offlinePorTiempo"
                    placeholder="Tiempo offline"
                    [items]="opcionesTiempo"
                    bindValue="valor"
                    bindLabel="etiqueta"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>

                  <ng-select
                    style="flex: 1 1 0"
                    formControlName="onlinePorTiempo"
                    placeholder="Tiempo online"
                    [items]="opcionesTiempo"
                    bindValue="valor"
                    bindLabel="etiqueta"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>
                </section>
              </div>
            </app-content-card>

            <!-- Resultados -->
            @if (buscado()) {
              <app-content-card
                [title]="'Sirenas encontradas (' + sirenas.length + ')'"
                icon="list"
              >
                @if (sirenas.length > 0) {
                  <span
                    card-header-actions
                    class="seleccionadas"
                    [class.limite]="seleccionadasCount >= LIMITE_SIRENAS"
                  >
                    {{ seleccionadasCount }} de {{ LIMITE_SIRENAS }}
                    seleccionadas
                  </span>
                }

                @if (seleccionadasCount >= LIMITE_SIRENAS) {
                  <app-info-banner
                    icon="warning"
                    color="yellow"
                    [title]="
                      'Límite alcanzado: máximo ' +
                      LIMITE_SIRENAS +
                      ' sirenas por operación'
                    "
                    message="Deseleccioná algunas para continuar cambiando la selección."
                    [closable]="false"
                    [margin]="'0 0 12px'"
                  ></app-info-banner>
                }

                @if (sirenas.length === 0) {
                  <app-empty-state
                    icon="search_off"
                    title="Sin resultados"
                    subtitle="No se encontraron sirenas con los filtros aplicados."
                  ></app-empty-state>
                } @else {
                  <div class="tabla-sirenas">
                    <div class="tabla-row header-row">
                      <span>
                        @if (sirenas.length < LIMITE_SIRENAS) {
                          <mat-checkbox
                            [checked]="todasSeleccionadas"
                            (change)="toggleSeleccionarTodas()"
                            matTooltip="Seleccionar todas"
                          ></mat-checkbox>
                        }
                      </span>
                      <span>Sincronización</span>
                      <span>Modelo</span>
                      <span>Chip ID</span>
                      <span>Dirección</span>
                      <span>Cliente</span>
                    </div>
                    @for (sirena of sirenas; track sirena._id) {
                      <div
                        class="tabla-row"
                        [class.seleccionada]="
                          sirenasSeleccionadas.has(sirena._id!)
                        "
                      >
                        <mat-checkbox
                          [checked]="sirenasSeleccionadas.has(sirena._id!)"
                          (change)="toggleSirena(sirena._id!)"
                        ></mat-checkbox>
                        <span>
                          @if (sirena.fechaSincronizacion) {
                            {{
                              sirena.fechaSincronizacion
                                | date: 'dd/MM/yyyy HH:mm'
                            }}
                          } @else {
                            <span class="no-info">Sin fecha</span>
                          }
                        </span>
                        <span>
                          @if (sirena.modelo) {
                            {{ sirena.modelo.marca }} -
                            {{ sirena.modelo.modelo }}
                          } @else {
                            <span class="no-info">Sin modelo</span>
                          }
                        </span>
                        <span>
                          @if (sirena.chipId) {
                            {{ sirena.chipId }}
                          } @else {
                            <span class="no-info">Sin chip ID</span>
                          }
                        </span>
                        <span>
                          @if (sirena.direccion) {
                            {{ sirena.direccion }}
                          } @else {
                            <span class="no-info">Sin dirección</span>
                          }
                        </span>
                        <span>
                          @if (sirena.cliente?.nombre) {
                            {{ sirena.cliente?.nombre }}
                          } @else {
                            <span class="no-info">Sin nombre</span>
                          }
                        </span>
                      </div>
                    }
                  </div>
                }
              </app-content-card>
            }
          </mat-step>

          <!-- ===== Paso 2: Datos del servicio técnico ===== -->
          <mat-step
            [stepControl]="servicioForm"
            errorMessage="Campos incompletos"
          >
            <ng-template matStepLabel>Datos del servicio</ng-template>

            <div [formGroup]="servicioForm">
              <app-content-card title="Información del servicio" icon="build">
                <section class="inputs-group">
                  <div style="flex: 2 1 0; min-width: 0">
                    <ng-select
                      formControlName="titulo"
                      placeholder="Título"
                      [items]="titulos"
                      appendTo="body"
                      notFoundText="Sin resultados"
                    ></ng-select>
                    @if (
                      servicioForm.controls.titulo.hasError('required') &&
                      servicioForm.controls.titulo.touched
                    ) {
                      <mat-error>El título es requerido</mat-error>
                    }
                  </div>

                  <ng-select
                    style="flex: 1 1 0"
                    formControlName="prioridad"
                    placeholder="Prioridad"
                    [items]="prioridadesItems"
                    [clearable]="false"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>
                </section>

                <section class="inputs-group">
                  <mat-form-field style="width: 100%">
                    <mat-label>Descripción</mat-label>
                    <textarea
                      matInput
                      rows="3"
                      formControlName="mensaje"
                      required
                    ></textarea>
                    <mat-icon matPrefix>description</mat-icon>
                    @if (servicioForm.controls.mensaje.hasError('required')) {
                      <mat-error>La descripción es requerida</mat-error>
                    }
                  </mat-form-field>
                </section>
              </app-content-card>

              <app-content-card title="Solicitante (opcional)" icon="person">
                <section class="inputs-group">
                  <mat-form-field style="flex: 1 1 0">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="solicitanteNombre" />
                    <mat-icon matPrefix>person</mat-icon>
                  </mat-form-field>

                  <mat-form-field style="flex: 1 1 0">
                    <mat-label>Teléfono</mat-label>
                    <input matInput formControlName="solicitanteTelefono" />
                    <mat-icon matPrefix>phone</mat-icon>
                  </mat-form-field>
                </section>

                <section class="inputs-group">
                  <mat-form-field style="width: 100%">
                    <mat-label>Email</mat-label>
                    <input
                      matInput
                      type="email"
                      formControlName="solicitanteEmail"
                    />
                    <mat-icon matPrefix>email</mat-icon>
                    @if (
                      servicioForm.controls.solicitanteEmail.hasError('email')
                    ) {
                      <mat-error>El email no es válido</mat-error>
                    }
                  </mat-form-field>
                </section>
              </app-content-card>
            </div>
          </mat-step>

          <!-- ===== Paso 3: Disponibilidad ===== -->
          <mat-step [optional]="true">
            <ng-template matStepLabel>Disponibilidad</ng-template>

            <div [formGroup]="servicioForm">
              <app-content-card
                title="Disponibilidad horaria"
                icon="date_range"
              >
                <app-rangos-horarios
                  formControlName="disponibilidad"
                ></app-rangos-horarios>
              </app-content-card>
            </div>
          </mat-step>

          <!-- ===== Paso 4: Técnico y confirmación ===== -->
          <mat-step [optional]="true">
            <ng-template matStepLabel>Técnico y confirmación</ng-template>

            <div [formGroup]="servicioForm">
              <app-content-card
                title="Técnico asignado (opcional)"
                icon="engineering"
              >
                <section class="inputs-group">
                  <ng-select
                    style="flex: 1 1 auto"
                    [items]="tecnicos"
                    bindValue="_id"
                    formControlName="idTecnicoAsignado"
                    placeholder="Técnico (sin asignar quedan como Pendiente)"
                    [notFoundText]="'No hay técnicos disponibles'"
                    [multiple]="false"
                    [searchable]="true"
                    appendTo="body"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <div class="tecnico-tag">
                        @if (item.datosPersonales?.foto) {
                          <div
                            class="tecnico-avatar"
                            [style.background-image]="
                              'url(' + item.datosPersonales.foto + ')'
                            "
                          ></div>
                        }
                        <span>
                          {{ item.datosPersonales?.nombre || item?.usuario }}
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <div class="tecnico-tag">
                        @if (item.datosPersonales?.foto) {
                          <div
                            class="tecnico-avatar"
                            [style.background-image]="
                              'url(' + item.datosPersonales.foto + ')'
                            "
                          ></div>
                        }
                        <span>
                          {{ item.datosPersonales?.nombre || item?.usuario }}
                        </span>
                      </div>
                    </ng-template>
                  </ng-select>

                  <app-button
                    matType="mat-fab"
                    color="primary"
                    icon="add"
                    tooltip="Crear nuevo técnico"
                    (click)="onAddTecnico()"
                  ></app-button>
                </section>
              </app-content-card>

              <!-- Resumen -->
              <app-content-card title="Resumen" icon="summarize">
                <div class="resumen-grid">
                  <div class="resumen-item">
                    <span class="resumen-label">Sirenas seleccionadas</span>
                    <span class="resumen-value destacado">
                      {{ seleccionadasCount }}
                    </span>
                  </div>
                  <div class="resumen-item">
                    <span class="resumen-label">Título</span>
                    <span class="resumen-value">
                      @if (servicioForm.controls.titulo.value) {
                        {{ servicioForm.controls.titulo.value }}
                      } @else {
                        <span class="no-info">Sin información</span>
                      }
                    </span>
                  </div>
                  <div class="resumen-item">
                    <span class="resumen-label">Prioridad</span>
                    <span class="resumen-value">
                      {{ servicioForm.controls.prioridad.value }}
                    </span>
                  </div>
                  <div class="resumen-item">
                    <span class="resumen-label">Estado inicial</span>
                    <span class="resumen-value">
                      {{
                        servicioForm.controls.idTecnicoAsignado.value
                          ? 'Asignado'
                          : 'Pendiente'
                      }}
                    </span>
                  </div>
                </div>
              </app-content-card>
            </div>
          </mat-step>
        </mat-stepper>
      </div>
    </mat-card-content>

    <!-- Pie: Cancelar | Anterior · Siguiente · Crear -->
    <mat-card-actions class="actions-create">
      <button irxBoton="secundario" type="button" (click)="cerrarDialog()">
        Cancelar
      </button>
      <span class="pie-espacio"></span>
      <button
        irxBoton="secundario"
        type="button"
        (click)="stepper.previous()"
        [disabled]="stepper.selectedIndex === 0"
      >
        <mat-icon>chevron_left</mat-icon>
        Anterior
      </button>
      @let ultimo = stepper.selectedIndex === stepper.steps.length - 1;
      @if (!ultimo) {
        <button
          irxBoton="secundario"
          type="button"
          (click)="stepper.next()"
          [disabled]="stepper.selectedIndex === 0 && seleccionadasCount === 0"
        >
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      }
      <button
        irxBoton="principal"
        type="button"
        (click)="onSubmit()"
        [disabled]="
          servicioForm.invalid || creando() || seleccionadasCount === 0
        "
      >
        @if (creando()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <mat-icon>check</mat-icon>
        }
        Crear {{ seleccionadasCount }} servicio(s)
      </button>
    </mat-card-actions>
  } @else {
    <mat-card-content class="card-content-crear">
      <!-- ===== Resultados finales ===== -->
      <div class="resultados-finales">
        @if (todosOk) {
          <app-info-banner
            icon="check_circle"
            color="green"
            title="Todos los servicios se crearon correctamente"
            [closable]="false"
            [margin]="'0 0 16px'"
          ></app-info-banner>
        } @else if (todosError) {
          <app-info-banner
            icon="error"
            color="red"
            title="No se pudo crear ningún servicio"
            [closable]="false"
            [margin]="'0 0 16px'"
          ></app-info-banner>
        } @else {
          <app-info-banner
            icon="warning"
            color="yellow"
            title="Creación parcial"
            [closable]="false"
            [margin]="'0 0 16px'"
          ></app-info-banner>
        }

        <div class="estadisticas-stat-cards">
          <app-stat-card
            icon="check_circle"
            title="Exitosos"
            [value]="resultadosOk"
            color="green"
            [margin]="'0'"
          ></app-stat-card>
          <app-stat-card
            icon="error"
            title="Con error"
            [value]="resultadosError"
            color="red"
            [margin]="'0'"
          ></app-stat-card>
        </div>

        <div class="lista-resultados">
          @for (r of resultados; track r.sirena._id) {
            <div
              class="resultado-item"
              [class.resultado-ok]="r.ok"
              [class.resultado-error]="!r.ok"
            >
              <mat-icon>{{ r.ok ? 'check_circle' : 'error' }}</mat-icon>
              <span class="resultado-chipid">
                {{ r.sirena.chipId || r.sirena._id }}
              </span>
            </div>
          }
        </div>
      </div>
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <button irxBoton="principal" type="button" (click)="cerrarDialog()">
        Cerrar
      </button>
    </mat-card-actions>
  }
</mat-card>
